import { PartnerTheme } from '@components/partner/enum';
import { PartnerStyle } from '@components/partner/model';

export const partnerStyle: { [key: string]: PartnerStyle } = {
  [PartnerTheme.BLUE]: {
    backgroundColor: 'BLUE',
    textColor: 'WHITE',
    buttonTheme: 'WHITE',
  },
  [PartnerTheme.OPAL]: {
    backgroundColor: 'OPAL',
    textColor: 'BLACK',
    buttonTheme: 'TRANSPARENT_BLACK',
  },
};
